import React, { useState } from 'react';

const ESTADOS = {
  borrador: { label: 'Borrador', color: '#6B6FD6', bg: '#E8E9F6' },
  en_proceso: { label: 'En proceso', color: '#d97706', bg: '#fef3c7' },
  listo_cliente: { label: 'Listo para cliente', color: '#2A7FFF', bg: '#dbeafe' },
  aprobado: { label: 'Aprobado', color: '#16a34a', bg: '#dcfce7' },
  rechazado: { label: 'Con cambios', color: '#dc2626', bg: '#fee2e2' },
};

const METODOS = [
  { key: 'email', label: 'Email', icon: '📧' },
  { key: 'foto', label: 'Foto / imagen', icon: '📷' },
  { key: 'firma', label: 'Firma digital', icon: '✍️' },
];

export default function DisenoDesarrolloDetalle({ proyecto, onActualizar, onCerrar }) {
  const [metodo, setMetodo] = useState(proyecto.metodoAprobacion || 'email');
  const [notasCambio, setNotasCambio] = useState('');
  const [showCambio, setShowCambio] = useState(false);

  const cambiarEstado = (nuevoEstado) => {
    const entrada = {
      fecha: new Date().toLocaleDateString('es-AR'),
      hora: new Date().toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' }),
      estado: nuevoEstado,
      notas: notasCambio,
    };
    const actualizado = {
      ...proyecto,
      estado: nuevoEstado,
      metodoAprobacion: metodo,
      historial: [entrada, ...(proyecto.historial || [])],
      version: nuevoEstado === 'rechazado' ? proyecto.version + 1 : proyecto.version,
    };
    onActualizar(actualizado);
    setNotasCambio('');
    setShowCambio(false);
  };

  const est = ESTADOS[proyecto.estado] || ESTADOS.borrador;

  return (
    <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden', display: 'flex', flexDirection: 'column', maxHeight: '80vh', overflowY: 'auto' }}>

      {/* Header */}
      <div style={{ padding: '16px', borderBottom: '1px solid #F3F4F6', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontWeight: '700', fontSize: '14px', color: '#111827' }}>{proyecto.nombre}</div>
          <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>DyD-{proyecto.id} · v{proyecto.version} · {proyecto.cliente || 'Sin cliente'}</div>
          <span style={{ display: 'inline-block', marginTop: '6px', background: est.bg, color: est.color, fontSize: '11px', padding: '2px 9px', borderRadius: '20px', fontWeight: '600' }}>{est.label}</span>
        </div>
        <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
      </div>

      {/* Ficha técnica */}
      <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6' }}>
        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Ficha técnica</div>
        {[
          { k: 'Formato', v: proyecto.formato },
          { k: 'Material', v: proyecto.material },
          { k: 'Colores', v: proyecto.colores },
          { k: 'Acabado', v: proyecto.acabado },
          { k: 'Tirada', v: proyecto.tirada },
          { k: 'Diseñador', v: proyecto.disenador },
          { k: 'OT vinculada', v: proyecto.ot ? `OT-${proyecto.ot}` : '—' },
          { k: 'Fecha creación', v: proyecto.fechaCreacion },
        ].map(({ k, v }) => v ? (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px' }}>
            <span style={{ color: '#6B7280' }}>{k}</span>
            <span style={{ color: '#111827', fontWeight: '500' }}>{v}</span>
          </div>
        ) : null)}
      </div>

      {/* Flujo ISO */}
      <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6' }}>
        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Flujo ISO §8.3</div>
        {[
          { num: 1, titulo: 'Planificación', sub: 'Brief / OT / solicitud interna', estados: ['borrador', 'en_proceso', 'listo_cliente', 'aprobado', 'rechazado'] },
          { num: 2, titulo: 'Arte finalizado', sub: 'Diseñador marca listo', estados: ['en_proceso', 'listo_cliente', 'aprobado', 'rechazado'] },
          { num: 3, titulo: 'Listo para cliente', sub: 'Enviado para aprobación', estados: ['listo_cliente', 'aprobado', 'rechazado'] },
          { num: 4, titulo: 'Aprobación cliente', sub: 'Email / foto / firma digital', estados: ['aprobado'] },
          { num: 5, titulo: 'Pasa a Pre Prensa', sub: '§8.3.5 · Transferencia', estados: ['aprobado'] },
        ].map((paso, i, arr) => {
          const done = paso.estados.includes(proyecto.estado);
          const isLast = i === arr.length - 1;
          return (
            <div key={paso.num} style={{ display: 'flex', gap: '10px', marginBottom: isLast ? 0 : '4px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{
                  width: '26px', height: '26px', borderRadius: '50%', flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '600',
                  background: done ? '#dcfce7' : '#F3F4F6',
                  color: done ? '#16a34a' : '#9CA3AF',
                  border: `1.5px solid ${done ? '#86efac' : '#E5E7EB'}`,
                }}>{done ? '✓' : paso.num}</div>
                {!isLast && <div style={{ width: '1px', flex: 1, background: '#E5E7EB', margin: '3px 0' }}></div>}
              </div>
              <div style={{ paddingBottom: isLast ? 0 : '12px' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', color: done ? '#111827' : '#9CA3AF' }}>{paso.titulo}</div>
                <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{paso.sub}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Aprobación cliente */}
      <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6' }}>
        <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Método de aprobación cliente</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
          {METODOS.map(m => (
            <button key={m.key} onClick={() => setMetodo(m.key)}
              style={{
                padding: '10px 6px', borderRadius: '10px', border: `1.5px solid ${metodo === m.key ? '#2A7FFF' : '#E5E7EB'}`,
                background: metodo === m.key ? '#dbeafe' : '#F9FAFB',
                color: metodo === m.key ? '#1d4ed8' : '#6B7280',
                fontSize: '11px', fontWeight: '600', cursor: 'pointer', textAlign: 'center',
              }}>
              <div style={{ fontSize: '18px', marginBottom: '4px' }}>{m.icon}</div>
              {m.label}
            </button>
          ))}
        </div>
      </div>

      {/* Acciones */}
      {proyecto.estado !== 'aprobado' && (
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6' }}>
          <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Acciones</div>
          {showCambio && (
            <textarea
              value={notasCambio}
              onChange={e => setNotasCambio(e.target.value)}
              placeholder="Notas del cambio de estado (opcional)..."
              style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #E5E7EB', fontSize: '12px', marginBottom: '8px', resize: 'vertical', minHeight: '60px', boxSizing: 'border-box' }}
            />
          )}
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {proyecto.estado === 'borrador' && (
              <button onClick={() => cambiarEstado('en_proceso')}
                style={{ flex: 1, padding: '8px', borderRadius: '8px', border: 'none', background: '#6B6FD6', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                ▶ Iniciar
              </button>
            )}
            {proyecto.estado === 'en_proceso' && (
              <button onClick={() => cambiarEstado('listo_cliente')}
                style={{ flex: 1, padding: '8px', borderRadius: '8px', border: 'none', background: '#2A7FFF', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                📤 Listo para cliente
              </button>
            )}
            {proyecto.estado === 'listo_cliente' && (<>
              <button onClick={() => cambiarEstado('aprobado')}
                style={{ flex: 1, padding: '8px', borderRadius: '8px', border: 'none', background: '#16a34a', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                ✅ Registrar aprobación
              </button>
              <button onClick={() => { setShowCambio(true); cambiarEstado('rechazado'); }}
                style={{ flex: 1, padding: '8px', borderRadius: '8px', border: '1px solid #E5E7EB', background: 'white', color: '#dc2626', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                🔄 Cliente pidió cambios
              </button>
            </>)}
            {proyecto.estado === 'rechazado' && (
              <button onClick={() => cambiarEstado('en_proceso')}
                style={{ flex: 1, padding: '8px', borderRadius: '8px', border: 'none', background: '#6B6FD6', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                🔁 Reabrir (v{proyecto.version})
              </button>
            )}
          </div>
        </div>
      )}

      {proyecto.estado === 'aprobado' && (
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6', background: '#f0fdf4' }}>
          <div style={{ fontSize: '13px', fontWeight: '600', color: '#16a34a' }}>✅ Aprobado por cliente</div>
          <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '4px' }}>Listo para pasar a Pre Prensa</div>
        </div>
      )}

      {/* Historial */}
      {proyecto.historial?.length > 0 && (
        <div style={{ padding: '14px 16px' }}>
          <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Historial de cambios</div>
          {proyecto.historial.map((h, i) => (
            <div key={i} style={{ fontSize: '11px', color: '#6B7280', marginBottom: '5px', paddingLeft: '10px', borderLeft: '2px solid #E5E7EB' }}>
              <span style={{ fontWeight: '600', color: '#374151' }}>{ESTADOS[h.estado]?.label}</span> · {h.fecha} {h.hora}
              {h.notas && <div style={{ color: '#9CA3AF', marginTop: '2px' }}>{h.notas}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
